var COPY_FEEDBACK_DURATION = 2000;
var API_TIMEOUT = 5000;
var CLAIM_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

function getClaimCacheKey(customerId, refCode) {
  return 'referral_claim:' + customerId + ':' + String(refCode || '').trim().toLowerCase();
}

function readClaimCache(customerId, refCode) {
  try {
    var raw = localStorage.getItem(getClaimCacheKey(customerId, refCode));
    if (!raw) return null;
    var entry = JSON.parse(raw);
    if (!entry || !entry.savedAt || Date.now() - entry.savedAt > CLAIM_CACHE_TTL_MS) {
      localStorage.removeItem(getClaimCacheKey(customerId, refCode));
      return null;
    }
    return entry;
  } catch (e) {
    return null;
  }
}

function writeClaimCache(customerId, refCode, data) {
  try {
    localStorage.setItem(getClaimCacheKey(customerId, refCode), JSON.stringify({
      coupon_code: (data && data.coupon_code) || '',
      redirect_link: (data && data.redirect_link) || '',
      savedAt: Date.now()
    }));
  } catch (e) {}
}

function initTncAccordion(sectionEl) {
  var triggers = sectionEl.querySelectorAll('[data-referral-accordion-trigger]');

  for (var i = 0; i < triggers.length; i++) {
    (function(trigger) {
      var wrapper = trigger.closest('[data-referral-accordion]');
      if (!wrapper) return;
      var content = wrapper.querySelector('.referral-tnc__content');
      if (!content) return;

      content.style.height = '0px';

      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        var toggle = trigger.querySelector('.referral-tnc__toggle');
        var isOpen = wrapper.classList.contains('referral-tnc--open');

        if (isOpen) {
          content.style.height = content.scrollHeight + 'px';
          content.offsetHeight;
          content.style.height = '0px';
          wrapper.classList.remove('referral-tnc--open');
          if (toggle) toggle.textContent = '+';
        } else {
          wrapper.classList.add('referral-tnc--open');
          content.style.height = content.scrollHeight + 'px';
          if (toggle) toggle.textContent = '\u2212';
        }
      });

      content.addEventListener('transitionend', function() {
        if (wrapper.classList.contains('referral-tnc--open')) {
          content.style.height = 'auto';
        }
      });
    })(triggers[i]);
  }
}

function initCopyCode(sectionEl) {
  var copyBtn = sectionEl.querySelector('.referral-code__copy');
  var codeValue = sectionEl.querySelector('.referral-code__value');
  if (!copyBtn || !codeValue) return;

  copyBtn.addEventListener('click', function() {
    var code = codeValue.textContent ? codeValue.textContent.trim() : '';
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).catch(function() {});
    } else {
      var textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }

    copyBtn.classList.add('referral-code__copy--copied');
    var originalSvg = copyBtn.innerHTML;
    copyBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

    setTimeout(function() {
      copyBtn.classList.remove('referral-code__copy--copied');
      copyBtn.innerHTML = originalSvg;
    }, COPY_FEEDBACK_DURATION);
  });
}

function buildShareMessage(sectionEl, code, shareUrl) {
  var template = (sectionEl.dataset.shareMessage || '').trim();
  if (!template) return shareUrl;

  // Merchants type the token loosely, so accept {{code}}, {{ code }} and {{CODE}},
  // and substitute every occurrence rather than just the first.
  return template.replace(/\{\{\s*code\s*\}\}/gi, code) + '\n\n' + shareUrl;
}

function initShareLink(sectionEl) {
  var shareBtn = sectionEl.querySelector('.referral-cta__share-btn');
  var codeValue = sectionEl.querySelector('.referral-code__value');
  if (!shareBtn || !codeValue) return;

  shareBtn.addEventListener('click', function() {
    var code = codeValue.textContent ? codeValue.textContent.trim() : '';
    if (!code) return;

    var shareUrl = 'https://www.wearcomet.com/pages/referral?ref=' + code;
    var message = buildShareMessage(sectionEl, code, shareUrl);

    if (navigator.share) {
      // Text only, no `url` key: several share targets (WhatsApp on iOS among them)
      // drop `text` when a `url` is also supplied, which would silently strip the
      // message and send a bare link. Chat apps auto-link the URL inside the text,
      // so the link preview is unaffected.
      navigator.share({
        text: message
      }).catch(function() {
        copyToClipboard(message);
        showBtnFeedback(shareBtn, 'Message Copied!');
      });
      return;
    }

    copyToClipboard(message);
    showBtnFeedback(shareBtn, 'Message Copied!');
  });
}

function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).catch(function() {});
  } else {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
}

function showBtnFeedback(btn, msg) {
  var originalText = btn.textContent;
  btn.textContent = msg;
  setTimeout(function() {
    btn.textContent = originalText;
  }, COPY_FEEDBACK_DURATION);
}

function getFeaturedCollectionSection() {
  var el = document.querySelector('.featured-coll');
  if (el) return el.closest('[id^="shopify-section-"]') || el;
  return null;
}

function hidePageLoader(sectionEl) {
  var loader = sectionEl.querySelector('[data-referral-loader]');
  if (loader) loader.style.display = 'none';
}

function showPageLoader(sectionEl) {
  var loader = sectionEl.querySelector('[data-referral-loader]');
  if (loader) loader.style.display = '';
}

function showState(sectionEl, state) {
  var fallbackLogin = sectionEl.querySelector('.referral-cta__fallback-login');
  var nonEligible = sectionEl.querySelector('.referral-cta__non-eligible');
  var eligible = sectionEl.querySelector('.referral-cta__eligible');
  var referee = sectionEl.querySelector('.referral-cta__referee');
  var steps = sectionEl.querySelector('.referral-steps');
  var tnc = sectionEl.querySelector('.referral-tnc');
  var bannerNoElig = sectionEl.querySelector('.referral-banner--non-eligible');
  var bannerElig = sectionEl.querySelector('.referral-banner--eligible');
  var bannerReferee = sectionEl.querySelector('.referral-banner--referee');
  var bannerPrelogin = sectionEl.querySelector('.referral-banner--prelogin');
  var bannerRefereeLogin = sectionEl.querySelector('.referral-banner--referee-login');
  var ctaLoggedOut = sectionEl.querySelector('.referral-cta__logged-out');
  var ctaArea = sectionEl.querySelector('.referral-cta');
  var featuredSection = getFeaturedCollectionSection();
  var loading = sectionEl.querySelector('.referral-loading');
  var errScreens = sectionEl.querySelectorAll('.referral-err');
  var layout = sectionEl.querySelector('.referral-layout');

  sectionEl.setAttribute('data-referral-state', state);

  if (loading) loading.classList.add('referral-loading--hidden');
  hidePageLoader(sectionEl);

  // Guest-only banner; the referee-login path re-shows it after this reset.
  if (bannerRefereeLogin) bannerRefereeLogin.style.display = 'none';

  // Reset every full-width error screen; ensure standard layout is visible.
  // Looped rather than named so a newly added .referral-err screen is reset automatically.
  for (var e = 0; e < errScreens.length; e++) errScreens[e].style.display = 'none';
  if (layout) layout.style.display = '';

  if (state === 'referee') {
    if (bannerPrelogin) bannerPrelogin.style.display = 'none';
    if (bannerNoElig) bannerNoElig.style.display = 'none';
    if (bannerElig) bannerElig.style.display = 'none';
    if (bannerReferee) bannerReferee.style.display = '';
    if (steps) steps.style.display = 'none';
    if (tnc) tnc.style.display = 'none';
    if (ctaLoggedOut) ctaLoggedOut.style.display = 'none';
    if (ctaArea) ctaArea.style.display = 'none';
    if (referee) referee.style.display = '';
    if (featuredSection) {
      featuredSection.style.display = '';
      featuredSection.classList.add('featured-coll--referee-visible');
    }
  } else if (state === 'eligible') {
    if (fallbackLogin) fallbackLogin.classList.add('referral-cta__fallback-login--hidden');
    if (nonEligible) nonEligible.classList.remove('referral-cta__non-eligible--visible');
    if (eligible) eligible.classList.add('referral-cta__eligible--visible');
    if (referee) referee.style.display = 'none';
    if (steps) steps.style.display = '';
    if (tnc) tnc.style.display = '';
    if (bannerElig) bannerElig.style.display = '';
    if (bannerNoElig) bannerNoElig.style.display = 'none';
    if (bannerReferee) bannerReferee.style.display = 'none';
    if (featuredSection) featuredSection.style.display = 'none';
  } else if (state === 'non-eligible') {
    // New customer who can't refer yet gets the same full-width screen the claim API's
    // "not eligible" response shows to an existing customer trying to claim — one message
    // for both audiences. The reset above re-showed .referral-layout, so hide it again.
    var errNotEligible = sectionEl.querySelector('.referral-err--not-eligible');
    if (errNotEligible) {
      if (layout) layout.style.display = 'none';
      errNotEligible.style.display = '';
      if (featuredSection) featuredSection.style.display = 'none';
      return;
    }
    if (fallbackLogin) fallbackLogin.classList.add('referral-cta__fallback-login--hidden');
    if (nonEligible) nonEligible.classList.add('referral-cta__non-eligible--visible');
    if (eligible) eligible.classList.remove('referral-cta__eligible--visible');
    if (referee) referee.style.display = 'none';
    if (steps) steps.style.display = 'none';
    if (tnc) tnc.style.display = 'none';
    if (bannerNoElig) bannerNoElig.style.display = '';
    if (bannerElig) bannerElig.style.display = 'none';
    if (bannerReferee) bannerReferee.style.display = 'none';
    if (featuredSection) featuredSection.style.display = '';
  } else if (state === 'fallback') {
    if (fallbackLogin) fallbackLogin.classList.add('referral-cta__fallback-login--visible');
    if (nonEligible) nonEligible.classList.remove('referral-cta__non-eligible--visible');
    if (eligible) eligible.classList.remove('referral-cta__eligible--visible');
    if (referee) referee.style.display = 'none';
    if (steps) steps.style.display = 'none';
    if (tnc) tnc.style.display = 'none';
    if (bannerNoElig) bannerNoElig.style.display = 'none';
    if (bannerElig) bannerElig.style.display = 'none';
    if (bannerReferee) bannerReferee.style.display = 'none';
    if (featuredSection) featuredSection.style.display = 'none';
  }
}

function initRefereeCopy(sectionEl) {
  // Scope to the result panel — the error-info halves also contain matching elements.
  var result = sectionEl.querySelector('.referral-referee__result');
  if (!result) return;
  var copyBtn = result.querySelector('.referral-referee__copy-btn');
  var codeValue = result.querySelector('.referral-referee__code-value');
  if (!copyBtn || !codeValue) return;

  copyBtn.addEventListener('click', function() {
    var code = codeValue.textContent ? codeValue.textContent.trim() : '';
    if (!code) return;

    copyToClipboard(code);
    var originalText = copyBtn.textContent;
    copyBtn.textContent = 'COPIED!';
    setTimeout(function() {
      copyBtn.textContent = originalText;
    }, COPY_FEEDBACK_DURATION);
  });
}

function showRefereeError(sectionEl, kind, message, refCode) {
  // Sets up referee state (hides loader, steps, tnc, cta; shows referee banner).
  // For known error kinds we then swap out the standard layout for the full-width
  // .referral-err screen; for an unknown kind we fall back to inline error text.
  showState(sectionEl, 'referee');

  var loginPrompt = sectionEl.querySelector('.referral-referee__login-prompt');
  var claiming = sectionEl.querySelector('.referral-referee__claiming');
  var result = sectionEl.querySelector('.referral-referee__result');
  var errorEl = sectionEl.querySelector('.referral-referee__error');
  var layout = sectionEl.querySelector('.referral-layout');
  // Whitelist, not a ternary: an unknown kind must fall back to 'generic', but every
  // screen that actually exists has to be listed here or it silently never renders.
  var suffix = ['generic', 'ineligible', 'self', 'not-eligible'].indexOf(kind) !== -1 ? kind : 'generic';
  var errEl = sectionEl.querySelector('.referral-err--' + suffix);

  if (loginPrompt) loginPrompt.style.display = 'none';
  if (claiming) claiming.style.display = 'none';
  if (result) result.style.display = 'none';

  if (errEl) {
    if (layout) layout.style.display = 'none';
    var codeValueEl = errEl.querySelector('.referral-referee__code-value');
    if (codeValueEl) codeValueEl.textContent = refCode || '';
    errEl.style.display = '';
    if (errorEl) errorEl.style.display = 'none';
    if (kind === 'generic') initErrorCopy(errEl);
    sectionEl.setAttribute('data-referral-state', 'referee-error-' + suffix);
    return;
  }

  if (errorEl) {
    errorEl.textContent = message || 'Something went wrong. Please try again.';
    errorEl.style.display = '';
  }
}

function initErrorCopy(wrapperEl) {
  var copyBtn = wrapperEl.querySelector('.referral-referee__copy-btn:not(.referral-referee__copy-btn--used)');
  var codeValue = wrapperEl.querySelector('.referral-referee__code-value');
  if (!copyBtn || !codeValue || copyBtn.dataset.bound === '1') return;
  copyBtn.dataset.bound = '1';

  copyBtn.addEventListener('click', function() {
    var code = codeValue.textContent ? codeValue.textContent.trim() : '';
    if (!code) return;
    copyToClipboard(code);
    var originalText = copyBtn.textContent;
    copyBtn.textContent = 'COPIED!';
    setTimeout(function() {
      copyBtn.textContent = originalText;
    }, COPY_FEEDBACK_DURATION);
  });
}

function initRefereeClaim(sectionEl, refCode) {
  var dataset = sectionEl.dataset;
  var loggedIn = dataset.customerLoggedIn === 'true';
  var loginPrompt = sectionEl.querySelector('.referral-referee__login-prompt');
  var claiming = sectionEl.querySelector('.referral-referee__claiming');
  var result = sectionEl.querySelector('.referral-referee__result');
  var errorEl = sectionEl.querySelector('.referral-referee__error');
  var proxyUrl = dataset.proxyUrl;

  if (!loggedIn) {
    // No API to wait on for logged-out users; set up referee state immediately so the login prompt renders.
    showState(sectionEl, 'referee');

    // Guests get the "login to claim" artwork, not the post-claim referee banner.
    var bannerReferee = sectionEl.querySelector('.referral-banner--referee');
    var bannerRefereeLogin = sectionEl.querySelector('.referral-banner--referee-login');
    if (bannerReferee) bannerReferee.style.display = 'none';
    if (bannerRefereeLogin) bannerRefereeLogin.style.display = '';

    // Distinct sub-state so the desktop-only heading can show via CSS.
    sectionEl.setAttribute('data-referral-state', 'referee-login');

    if (loginPrompt) loginPrompt.style.display = '';
    var loginBtn = sectionEl.querySelector('.referral-referee__login-btn');
    if (loginBtn) {
      loginBtn.href = loginBtn.href.replace(
        /checkout_url=[^&]*/,
        'checkout_url=/pages/referral?ref=' + encodeURIComponent(refCode)
      );
    }
    return;
  }

  // Logged in. Loader stays visible across the API roundtrip so the referee
  // banner doesn't flash before the final state (result or error wrapper).

  var name = dataset.customerName || '';
  var phone = (dataset.customerPhone || '').replace(/^\+91/, '').replace(/\D/g, '');

  if (!name || !phone || !proxyUrl) {
    showState(sectionEl, 'referee');
    if (loginPrompt) loginPrompt.style.display = 'none';
    if (claiming) claiming.style.display = 'none';
    if (errorEl) {
      errorEl.textContent = !name ? 'Name is required on your account to claim referral.' : !phone ? 'Phone number is required on your account to claim referral.' : 'Proxy URL is not configured.';
      errorEl.style.display = '';
    }
    return;
  }

  var base = proxyUrl.replace(/\/+$/, '');
  var customerId = dataset.customerId || '';

  function renderClaimSuccess(couponCode, redirectLink) {
    showState(sectionEl, 'referee');
    if (loginPrompt) loginPrompt.style.display = 'none';
    if (claiming) claiming.style.display = 'none';

    // Scope to result panel — full-width error screens also contain a matching .code-value.
    var codeEl = result ? result.querySelector('.referral-referee__code-value') : null;
    if (codeEl) codeEl.textContent = couponCode || '';

    // Attach the referral discount to the Shopify session the moment it's claimed.
    // Shop Now already does this implicitly by routing through Nector's /discount/<code>
    // redirect link; doing it here makes the discount carry to checkout regardless of how
    // the shopper adds items (product tray add-to-cart, normal browsing) — not just Shop Now.
    // Fire-and-forget: /discount/<code> stores a pending discount that's valid even with an
    // empty cart and never blocks or breaks the claim UI. Same mechanism as comet-discount.js.
    if (couponCode) {
      fetch('/discount/' + encodeURIComponent(couponCode)).catch(function() {});
    }

    // Suppress the cart's generic "Offers Available At Checkout" strip for the rest of this
    // tab session — it advertises a coupon that can't stack with the referral discount.
    // sessionStorage (not localStorage) so it clears itself when the tab closes.
    // Logged-in only: customerId is 'shopify-<id>' and empty for the guest claim path.
    if (customerId) {
      try {
        sessionStorage.setItem('referral_claimed', '1');
      } catch (e) {}
      // Applied directly too, for the shopper who opens the cart without a fresh page load.
      document.body.classList.add('referral-claimed');
    }

    if (result) result.style.display = '';
    // Distinct sub-state so the success-only announce strip can show via CSS.
    sectionEl.setAttribute('data-referral-state', 'referee-success');
    initRefereeCopy(sectionEl);
  }

  function proceedToClaim() {
    fetch(base + '/api/referral/claim', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ referral_code: refCode, name: name, mobile: phone })
    })
    .then(function(response) { return response.json().then(function(data) { return { ok: response.ok, data: data }; }); })
    .then(function(res) {
      if (!res.ok) {
        var nectorMsg = (res.data && res.data.detail && res.data.detail.data && res.data.detail.data.message) || '';
        var apiMsg = nectorMsg || (res.data && res.data.error) || '';
        // Nector answers an unexplained claim rejection with detail.data.message =
        // "Something went wrong" (HTTP 422, error: "Claim referral failed") — in practice the
        // already-claimed case. That, and a rejection carrying no message at all, both get the
        // "referral reward unavailable" screen. Anything with a real message keeps the Oops
        // screen so the shopper actually sees what Nector said.
        var lower = nectorMsg.toLowerCase();
        if (!apiMsg || lower.indexOf('something went wrong') !== -1) {
          showRefereeError(sectionEl, 'ineligible', '', refCode);
          return;
        }
        // "Unable to process the referral at the moment, you are not eligible" — matched on the
        // substring so a re-worded preamble on Nector's side does not break the routing.
        if (lower.indexOf('not eligible') !== -1) {
          showRefereeError(sectionEl, 'not-eligible', '', refCode);
          return;
        }
        showRefereeError(sectionEl, 'generic', apiMsg, refCode);
        return;
      }

      if (customerId) writeClaimCache(customerId, refCode, res.data);
      renderClaimSuccess(res.data.coupon_code, res.data.redirect_link);
    })
    .catch(function() {
      showRefereeError(sectionEl, 'generic', 'Something went wrong. Please try again.', refCode);
    });
  }

  if (customerId) {
    var cachedClaim = readClaimCache(customerId, refCode);
    if (cachedClaim) {
      renderClaimSuccess(cachedClaim.coupon_code, cachedClaim.redirect_link);
      return;
    }
  }

  if (!customerId) {
    proceedToClaim();
    return;
  }

  fetch(base + '/api/referral?customer_id=' + encodeURIComponent(customerId), {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
  })
  .then(function(response) { return response.ok ? response.json() : null; })
  .then(function(data) {
    var ownCode = (data && data.referral_code ? String(data.referral_code) : '').trim().toLowerCase();
    var attempted = String(refCode || '').trim().toLowerCase();
    if (ownCode && attempted && ownCode === attempted) {
      showRefereeError(sectionEl, 'self', '', refCode);
      return;
    }
    proceedToClaim();
  })
  .catch(function() {
    proceedToClaim();
  });
}

function getRefCodeFromUrl() {
  var params = new URLSearchParams(window.location.search);
  return params.get('ref') || '';
}

function initReferralApi(sectionEl) {
  try {
    var dataset = sectionEl.dataset;
    var customerId = dataset.customerId;
    var proxyUrl = dataset.proxyUrl;
    var customerLoggedIn = dataset.customerLoggedIn;
    var customerEligible = dataset.customerEligible;

    if (customerLoggedIn !== 'true') return;

    var featuredSection = getFeaturedCollectionSection();
    if (featuredSection) featuredSection.style.display = 'none';

    // Eligibility (orders + spend + first order > 7 days ago) is decided in Liquid.
    // Ineligible customers never hit the Nector API.
    if (customerEligible !== 'true') {
      showState(sectionEl, 'non-eligible');
      return;
    }

    if (!customerId || !proxyUrl) {
      showState(sectionEl, 'fallback');
      return;
    }

    var controller = new AbortController();
    var timeoutId = setTimeout(function() { controller.abort(); }, API_TIMEOUT);

    var url = proxyUrl.replace(/\/+$/, '') + '/api/referral?customer_id=' + encodeURIComponent(customerId);

    fetch(url, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      signal: controller.signal
    })
    .then(function(response) {
      clearTimeout(timeoutId);
      if (!response.ok) {
        console.warn('[Referral] Proxy API error: ' + response.status);
        showState(sectionEl, 'fallback');
        return null;
      }
      return response.json();
    })
    .then(function(data) {
      if (!data) return;

      // Customer is already known-eligible; we only need the code from the API.
      var referralCode = data.referral_code || '';

      if (referralCode) {
        var codeEl = sectionEl.querySelector('.referral-code__value');
        if (codeEl) codeEl.textContent = referralCode;
        showState(sectionEl, 'eligible');
        initCopyCode(sectionEl);
        initShareLink(sectionEl);
      } else {
        // Eligible, but no code came back — treat as a transient API issue.
        showState(sectionEl, 'fallback');
      }
    })
    .catch(function(error) {
      clearTimeout(timeoutId);
      console.warn('[Referral] Proxy fetch failed:', error.message || error);
      showState(sectionEl, 'fallback');
    });
  } catch (err) {
    console.warn('[Referral] initReferralApi crashed:', err.message || err);
    showState(sectionEl, 'fallback');
  }
}

function initDesignModePreview(sectionEl) {
  var codeEl = sectionEl.querySelector('.referral-code__value');
  if (codeEl) codeEl.textContent = 'COMETLOVESCOMET';
  showState(sectionEl, 'eligible');
  initCopyCode(sectionEl);
  initShareLink(sectionEl);
}

function initSection(sectionEl) {
  initTncAccordion(sectionEl);

  if (window.Shopify && window.Shopify.designMode) {
    initDesignModePreview(sectionEl);
    return;
  }

  var refCode = getRefCodeFromUrl();
  if (refCode) {
    showPageLoader(sectionEl);
    initRefereeClaim(sectionEl, refCode);
    return;
  }

  initReferralApi(sectionEl);
}

function bootSections() {
  var sections = document.querySelectorAll('[data-section-id].referral-section');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSections);
} else {
  bootSections();
}

document.addEventListener('shopify:section:load', function(event) {
  var section = event.target.querySelector('[data-section-id].referral-section');
  if (section) initSection(section);
});
